import { State } from 'business/models/Models';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useMemo, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import {
  useIngredientCASNumbers,
  usecasNumberErrors,
} from 'redux/hooks/IngredientDetail';
import {
  addCASNumber,
  removeCASNumbers,
  updateCASNumberById,
} from 'redux/reducers/ingredientDetailReducer';
import { IStyle } from 'Styles';
import { getNewId } from 'utils/Global';
import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';

const CASNUMBER_COLUMNS = [{ accessor: 'name', Header: 'CAS Numbers' }];

const CASNumbers = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const casNumbers = useIngredientCASNumbers();
  const errors = usecasNumberErrors();
  const dispatch = useRMDispatch();

  const onCellChanged = (e, casId) => {
    dispatch(
      updateCASNumberById({
        id: casId,
        number: e.target.value,
        state: casId > 0 ? State.New : State.Updated,
      }),
    );
  };

  const handleAddCASNumber = () => {
    dispatch(addCASNumber({ id: getNewId(), number: '', state: State.New }));
  };

  const handleDeleteCASNumbers = () => {
    if (selectedRows?.length) {
      dispatch(
        removeCASNumbers(
          selectedRows.map((i) => {
            return casNumbers[i];
          }),
        ),
      );
      setSelectedRows([]);
    }
  };

  const addCASIcon: RMCustomButtonProps = {
    Icon: <RMSvgIcon id='casnumbers-svg-add-icon' name="New" className="w-8 h-8 cursor-pointer" />,
    titleTip: 'Add CAS Numbers',
    onClick: handleAddCASNumber,
  };

  const deleteCASIcon: RMCustomButtonProps = {
    Icon: (
      <RMSvgIcon id='casnumbers-svg-del-icon' subfolder="Setup" name="Remove" className="w-8 h-8 cursor-pointer" />
    ),
    titleTip: 'Delete CAS Numbers',
    onClick: handleDeleteCASNumbers,
  };

  const aliasesRows = useMemo(
    () =>
      casNumbers.map((a) => {
        return {
          name: (
            <input
              id="casnumbers-aliasesrows-input-number"
              autoFocus
              type="text"
              className="w-full border-none bg-transparent text-left h-8"
              onChange={(e) => onCellChanged(e, a.id)}
              value={a.number}
            />
          ),
        };
      }),
    [casNumbers, onCellChanged],
  );

  const handleSelectionChange = (rowIndices) => {
    setSelectedRows(rowIndices);
  };

  return (
    <div
      id="casnumbers-main-container"
      className="flex basis-full flex-col max-h-full dashed-border"
    >
      <div id="casnumbers-title" className="basis-1/12 p-2 font-bold">
        CAS Numbers
      </div>
      <div id="casnumbers-table" className="basis-8/12 flex max-h-[12vh]">
        <RMTable
          rowExtraInfo={errors}
          data={aliasesRows}
          columns={CASNUMBER_COLUMNS}
          selectedIds={selectedRows}
          onCheckboxSelectionChange={handleSelectionChange}
          mainContainerStyle={styles.tableStyle}
          cellClassName="justify-start"
        />
      </div>
      <div
        id="casnumbers-buttons-wrapper"
        className="basis-3/12 flex gap-2 px-2 pb-1 items-end"
      >
        <RMCustomButton {...addCASIcon} />
        <RMCustomButton {...deleteCASIcon} />
      </div>
    </div>
  );
};

const styles: IStyle = {
  tableStyle: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
};

export default CASNumbers;
